import { useTranslationNameSpace, NAME_SPACES } from 'i18n/hooks';
import {
  FlexColumn,
  TEXT_TYPES,
  COLORS,
  TEXT_WEIGHTS,
  FlexRow,
  Button,
  BUTTON_TYPES,
  Text,
} from 'modules/ui/components';
import { PageTitle } from 'modules/ui/components/PageTitle';
import { useCallback } from 'react';
import { Marker } from './styled';
import { terms } from './utils';

export const MobileTermsOfService = () => {
  const { t } = useTranslationNameSpace(NAME_SPACES.PAGES);

  const onPrint = useCallback(() => window.print(), []);

  return (
    <FlexColumn
      w="100%"
      h="100%"
      bg="url(./assets/backgrounds/background-4.png)"
      bgSize="cover"
    >
      <PageTitle title={t('termsOfService.title')} />
      <FlexColumn
        w="100%"
        alignItems="center"
        position="relative"
        p="10px 0 100px 0"
      >
        <FlexColumn w="80%" alignItems="center">
          {terms.map(({ items, lists }, i) => (
            <FlexColumn w="100%" gap="17px" m="40px 0">
              <Text
                size="35px"
                type={TEXT_TYPES.title}
                color={COLORS.lightBlue}
                weight={TEXT_WEIGHTS.bolder}
                lineHeight="32px"
                whiteSpace="pre-wrap"
              >
                {t(`termsOfService.terms.${i}.title`)}
              </Text>
              {items.map((text, textIndex) => {
                const list = lists.find(
                  (l: { position: number; list: string[] }) =>
                    l.position === textIndex,
                )!;
                const listIndex = lists.findIndex(
                  (l: { position: number; list: string[] }) =>
                    l.position === textIndex,
                );

                return (
                  <>
                    {list?.list.map((text, listItemIndex) => (
                      <FlexRow w="100%" gap="15px">
                        <Marker />
                        <Text
                          size="20px"
                          type={TEXT_TYPES.text}
                          color={COLORS.white}
                          weight={TEXT_WEIGHTS.tiny}
                          letterSpacing="0.56px"
                          lineHeight="25px"
                        >
                          {t(
                            `termsOfService.terms.${i}.lists.${listIndex}.${listItemIndex}`,
                          )}
                        </Text>
                      </FlexRow>
                    ))}
                    <Text
                      size="20px"
                      type={TEXT_TYPES.text}
                      color={COLORS.white}
                      weight={TEXT_WEIGHTS.tiny}
                      letterSpacing="0.56px"
                      lineHeight="25px"
                      whiteSpace="pre-wrap"
                    >
                      {t(`termsOfService.terms.${i}.texts.${textIndex}`)}
                    </Text>
                  </>
                );
              })}
            </FlexColumn>
          ))}
          <FlexColumn w="100%" gap="40px" alignItems="center" m="50px 0 0 0">
            <img src="./assets/terms/print.png" alt="print" />
            <Button
              style={{ width: '70%' }}
              buttonType={BUTTON_TYPES.filled}
              onClick={onPrint}
            >
              {t(`termsOfService.button`)}
            </Button>
          </FlexColumn>
        </FlexColumn>
      </FlexColumn>
    </FlexColumn>
  );
};
